import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LowercaseButton from "../../../components/LowercaseButton/LowercaseButton";
import React, { useState } from "react";
import PrivilegeDialog from "../PrivilegeDialog/PrivilegeDialog";
import { Privilege } from "../Models/Privilige";
import { prepareDisplayOfTimeStamp } from "../../../utility/FormatTimeStamp";
import {
  CREATED,
  DELETE,
  DESCRIPTION,
  EDIT,
  PRIVILEGE_DELETE,
  PRIVILEGE_DELETE_CONFIRMATION,
  PRIVILEGE_EDIT,
  PRIVILEGE_REFERENCE_NAME,
} from "../../../utility/TextLabels";
import ConfirmationDialog from "../../../components/ConfirmationDialog/ConfirmationDialog";

type PrivilegeItemProps = {
  privilege: Privilege;
  onUpdatePrivilege: (privilege: Privilege) => void;
  onDeletePrivilege: (privilege: Privilege) => void;
};

const PrivilegeItem: React.FC<PrivilegeItemProps> = ({
  privilege,
  onUpdatePrivilege,
  onDeletePrivilege,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  const titleStyle = {
    gutterBottom: true,
    fontFamily: "Lato",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
  };

  const fieldStyle = {
    paragraph: true,
    color: "#707070",
    fontFamily: "Lato",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
  };

  const timeStampStyle = {
    color: "#A6A6A6",
    fontFamily: "Lato",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
  };

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        paddingBottom: 1,
        paddingLeft: 2,
        paddingRight: 3,
        paddingTop: 1,
      }}
    >
      <Box>
        <Typography variant="h6" {...titleStyle}>
          {privilege.name}
        </Typography>
        <Typography variant="body1" {...fieldStyle}>
          {PRIVILEGE_REFERENCE_NAME}: {privilege.referenceName}
        </Typography>
        <Typography variant="body1" {...fieldStyle}>
          {DESCRIPTION}: {privilege.description}
        </Typography>
        <Typography {...timeStampStyle}>
          {CREATED}:{" "}
          {privilege.creationTimeStamp
            ? prepareDisplayOfTimeStamp(privilege.creationTimeStamp)
            : ""}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "1em",
          alignItems: "flex-end",
        }}
      >
        <LowercaseButton color="primary" onClick={() => setIsOpen(true)}>
          {EDIT}
        </LowercaseButton>
        <PrivilegeDialog
          title={PRIVILEGE_EDIT}
          existingId={privilege.id!}
          existingName={privilege.name}
          existingReferenceName={privilege.referenceName}
          existingDescription={privilege.description ?? ""}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          onSubmit={onUpdatePrivilege}
        />
        <LowercaseButton
          color="secondary"
          onClick={() => setIsConfirmationOpen(true)}
        >
          {DELETE}
        </LowercaseButton>
        <ConfirmationDialog
          title={PRIVILEGE_DELETE}
          text={PRIVILEGE_DELETE_CONFIRMATION}
          isOpen={isConfirmationOpen}
          onClose={() => setIsConfirmationOpen(false)}
          onSubmit={() => onDeletePrivilege(privilege)}
        />
      </Box>
    </Box>
  );
};

export default PrivilegeItem;
